import script from "./UserAuth.vue?vue&type=script&setup=true&lang=js"
export * from "./UserAuth.vue?vue&type=script&setup=true&lang=js"

import "./UserAuth.vue?vue&type=style&index=0&id=79babe8e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anteater\\Desktop\\projects\\main-prj-01-starting-setup\\main-prj-01-starting-setup\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79babe8e"]])

export default __exports__